// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import Autosuggest, { InputProps } from 'react-autosuggest';

import Select2, { DataSelect2 } from 'wdna-select2';

import { ActionDO } from '../../../requests';
import { CommandDO, VariableDO } from '../../../../configuration/requests';

type Generic = { id: string; name: string; }
const ACTION_TYPE: Generic[] = [
  { id: 'HARDWARE', name: 'HARDWARE' },
  { id: 'EMAIL', name: 'EMAIL' },
  { id: 'SMS', name: 'SMS' },
  { id: 'VOICE', name: 'VOICE' },
];

interface Props {
  formValues: {
    variableArray: VariableDO[];
    data?: Partial<ActionDO>;
  };
  inputProps1: InputProps<any>;
  inputProps2: InputProps<any>;
  suggestions: CommandDO[];
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onChangeStandard: (e: React.ChangeEvent<HTMLInputElement>) => void;
  renderSuggestion: (suggestion: CommandDO, params: any) => React.ReactNode;
  getSuggestionValue: (suggestion: CommandDO) => string;
  onSuggestionsFetchRequested: (r: any) => void;
  onSuggestionsClearRequested: () => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
function Form(props: Props): JSX.Element {
  const { variableArray, data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Action</b>
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data?.name || ''}
            name="name"
            onChange={props.onChangeStandard}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Type</b>
          </label>
          <Select2
            name="type"
            data={ACTION_TYPE.map((item: Generic): DataSelect2 => {
              return { id: item.id, text: item.name };
            })}
            value={data?.type || ''}
            options={{
              placeholder: 'Select option',
            }}
            onChange={props.onChange}
            style={{ width: '80%' }}
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>State Variable</b>
          </label>
          <Select2
            name="variable.id"
            data={variableArray.map((item: VariableDO): DataSelect2 => {
              return { id: item.id, text: item.name };
            })}
            value={data?.variable?.id || ''}
            options={{
              placeholder: 'Select option',
            }}
            onChange={props.onChange}
            style={{ width: '80%' }}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Command</b>
          </label>
          <Autosuggest<CommandDO>
            suggestions={props.suggestions}
            onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={props.onSuggestionsClearRequested}
            getSuggestionValue={props.getSuggestionValue}
            renderSuggestion={props.renderSuggestion}
            inputProps={props.inputProps1}
            highlightFirstSuggestion
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Refusal Command</b>
          </label>
          <Autosuggest<CommandDO>
            suggestions={props.suggestions}
            onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={props.onSuggestionsClearRequested}
            getSuggestionValue={props.getSuggestionValue}
            renderSuggestion={props.renderSuggestion}
            inputProps={props.inputProps2}
            highlightFirstSuggestion
          />
        </div>
      </div>
    </fieldset>
  );
}

export default Form;
